<template>
	<div class="RechargeAmount">
		<el-button type="primary" @click="dialogVisible = true">{{$t('Mywallet.Recharge')}}</el-button>

		<el-dialog 
		:title="$t('Mywallet.AccountRecharge')" 
		:visible.sync="dialogVisible" 
		width="40%" 
		:before-close="handleClose" center :close-on-click-modal="false">
			<div class="pay">
				<span class="payUser"><span style="margin-right: 10px;">{{$t('Mywallet.RechargeAccount')}} :</span> {{ DataMoney.loginname }}</span>
				<span class="payBalance"><span style="margin-right: 10px;">{{$t('Mywallet.AccountBalance')}} :</span> {{ DataMoney.usableMoney || 0 }} {{$t('Mywallet.RMB') }}</span>
				<span class="payMoney">
					<span style="margin-right: 10px;">{{$t('Mywallet.RechargeAmount')}} :</span>
					<el-input-number style="margin-right: 10px;" size="small" v-model="payMoney" controls-position="right" :min="10"></el-input-number>
					<span class="payMoneyinptitle">{{$t('Mywallet.RMB') }} {{$t('Mywallet.RechargeLeast10') }}{{$t('Mywallet.RMB') }}</span>
				</span>
				<span class="payMode">
					<span style="margin-right: 10px;">{{$t('Mywallet.PaymentMethod')}} :</span>
					<el-button size="small" @click="payModezfb">
						{{$t('Mywallet.Alipay') }}
					</el-button>
					<el-button size="small" @click="payModewx">
						{{$t('Mywallet.WeChat') }}
					</el-button>
					<el-button size="small" @click="payModeyh">
						{{$t('Mywallet.BankTransfer') }}
					</el-button>
				</span>
			</div>

			<span slot="footer" class="dialog-footer">
				<el-button size="small" @click="dialogVisible = false">{{$t('main.cancel2') }}</el-button>
				<el-button size="small" type="primary" @click="payment">{{$t('Mywallet.Payment') }}</el-button>
			</span>

			<span></span>
		</el-dialog>
	</div>
</template>

<script>
export default {
	name: 'RechargeAmount',
	components: {},
	data() {
		return {
			num: 0,
			dialogVisible: false,
			payMoney: '', //充值账户
			DataMoney: {} //金钱
		};
	},
	mounted: function() {
		this.queryDownloadRecord();
	},
	methods: {
		payment() {
			if (this.num === 1) {
				window.open(this.$config.service.alipay + '?money=' + this.payMoney + '&Authorization=' + 'Bearer ' + window.localStorage.getItem('token'));
			}
			if (this.num === 2) {
			}
			if (this.num === 3) {
			}
			this.$emit('payment', this.$t('Mywallet.ClickPayment'));
			this.dialogVisible = false;
		},
		handleClose(done) {
			done();
		},
		payModezfb() {
			this.num = 1;
		},
		payModewx() {
			this.num = 2;
		},
		payModeyh() {
			this.num = 3;
		},
		queryDownloadRecord() {
			let that = this;
			let params = {
				that: this,
				url: `${this.$config.service.mywallet}`,
				method: 'POST',
				cb(res) {
					if (res.code == 0) {
						that.DataMoney = res.resultBody;
					}
				}
			};
			this.$util.request(params);
		}
	}
};
</script>

<style scoped="scoped" lang="scss">
.RechargeAmount {
	display: inline-block;
	margin-right: 5px;
	.pay {
		height: 190px;
		display: flex;
		flex-direction: column;
		justify-content: space-between;
		.payUser {
			color: #333333;
			font-size: 16px;
		}
		.payBalance {
			font-size: 16px;
			color: #333333;
		}
		.payMoney {
			font-size: 16px;
			color: #333333;
			.payMoneyinp {
				width: 100px;
				height: 30px;
			}
			.payMoneyinptitle {
				font-size: 14px;
				color: #666666;
			}
		}
		.payMode {
			line-height: 40px;
			font-size: 16px;
			color: #333333;
			display: flex;
		}
	}
}
//充值对话框
</style>
